import React from "react";
import "../chatwidget/chatwidget.css";

const ChatLauncher = ({ onClick }) => {
  return (
    <button 
      onClick={onClick} 
      className="chat-launcher-button"
      aria-label="Open chat"
      type="button"
    >
      <span className="launcher-icon">💬</span>
      <span className="launcher-text">Need Help?</span>
    </button>
  );
};

export default ChatLauncher;